import { Controller } from 'stimulus';

class WorkingAt extends Controller {
  // eslint-disable-next-line class-methods-use-this
  onVacancyClick(event) {
    if (event.target.tagName === 'A' || event.target.tagName === 'BUTTON') {
      return true;
    }

    const { currentTarget } = event;
    const firstLink = currentTarget.querySelector('a');

    if (firstLink) {
      window.location = firstLink.href;
      return false;
    }

    return true;
  }
}

WorkingAt.targets = [
  //
];

export default WorkingAt;
